import styled from 'styled-components';
import { black, boxShadow1 } from './colors';

export const Box = styled('div')`
  border-radius: 10px;
  box-shadow: ${boxShadow1};
  background-color: var(--exact-white);
  padding: 1rem;
`;

export const SpaceBetween = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`;

export const Flex = styled('div')`
  display: flex;
`;

export const Centered = styled('div')`
  text-align: center;
`;

export const LayoutContainer = styled('section')`
  background-repeat: repeat;
  display: flex;
  flex-direction: ${(props) => (props.dir ? props.dir : 'column')};
  flex: auto;
  position: relative;
  min-height: 100dvh;
  max-height: 100dvh;
  background-color: var(--exact-white);
`;

export const HeaderContainer = styled('header')`
  background: var(--exact-white);
  box-shadow: ${boxShadow1};
  color: #009eb0;
  font-weight: normal;
  flex: 0 0 auto;
  height: 48px;
  line-height: 48px;
  padding: 0 36px;
  //z-index: 1001;
  @media (max-width: 500px) {
    padding: 0 1rem;
  }
`;

interface ContentContainerProps {
  stickToLeft?: boolean;
}
export const ContentContainer = styled('main')<ContentContainerProps>`
  display: flex;
  flex-direction: column;
  flex: auto;
  margin: 24px 24px 24px ${(props) => (props.stickToLeft ? '0' : '24px')};
  transition: 'all 0.5s ease-in-out';
  min-height: 0;
  overflow: initial;
  overflow: visible;
  background: var(--exact-white);

  max-height: 100%;

  @media only screen and (max-width: 1100px) {
    margin: 0;
  }
`;

export const HideOnMobile = styled('span')`
  color: ${black};
  & > iframe {
    border-radius: 1rem;
  }
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export const ShowOnMobile = styled('span')`
  @media only screen and (min-width: 481px) {
    display: none;
  }
`;

export const MessageFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 10px;
`;
